/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-catch */
import axios from 'axios';

// Use your actual backend URL or relative path if using a proxy
const API_URL = `${process.env.REACT_APP_TXHASH_URL}manual/process-tx`;
const RENTAL_API_URL = `${process.env.REACT_APP_API_URL}/rental/rentDescription`;

export async function sendTransactionHash(txHash: string) {
  try {
    const response = await axios.post(API_URL, { txHash });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function createRental(rentalData: any) {
  try {
    const response = await axios.post(RENTAL_API_URL, rentalData, {
      headers: {
        'Content-Type': 'application/json', // Use JSON
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
